(function($) {
    $(document).ready(function() {
        // Kategorien und Sportarten laden
        const blockContainer = document.querySelector('.soswi-eventcalendar');
        const categories = JSON.parse(blockContainer.dataset.categories);
        const sporttypes = JSON.parse(blockContainer.dataset.sporttypes);
        const currentLang = blockContainer.dataset.lang || 'de';

        // Mehrsprachige Texte
        const translations = {
            'de': {
                'eventLink': 'Zur Veranstaltung',
                'noEvents': 'Keine Events gefunden.',
                'errorLoading': 'Fehler beim Laden der Events. Bitte versuchen Sie es später erneut.',
                'upcomingEvents': 'Kommende Veranstaltungen',
                'resetDate': 'Datum zurücksetzen',
                'loadingEvents': 'Events werden geladen...',
                'showPastEvents': 'Vergangene Veranstaltungen',
                'showFutureEvents': 'Zukünftige Veranstaltungen'
            },
            'fr': {
                'eventLink': 'À l\'événement',
                'noEvents': 'Aucun événement trouvé.',
                'errorLoading': 'Erreur lors du chargement des événements. Veuillez réessayer plus tard.',
                'upcomingEvents': 'Événements à venir',
                'resetDate': 'Réinitialiser la date',
                'loadingEvents': 'Chargement des événements...',
                'showPastEvents': 'Événements passés',
                'showFutureEvents': 'Événements futurs'
            },
            'it': {
                'eventLink': 'All\'evento',
                'noEvents': 'Nessun evento trovato.',
                'errorLoading': 'Errore durante il caricamento degli eventi. Si prega di riprovare più tardi.',
                'upcomingEvents': 'Eventi futuri',
                'resetDate': 'Reimposta data',
                'loadingEvents': 'Caricamento degli eventi...',
                'showPastEvents': 'Eventi passati',
                'showFutureEvents': 'Eventi futuri'
            },
            'en': {
                'eventLink': 'To the event',
                'noEvents': 'No events found.',
                'errorLoading': 'Error loading events. Please try again later.',
                'upcomingEvents': 'Upcoming Events',
                'resetDate': 'Reset date',
                'loadingEvents': 'Loading events...',
                'showPastEvents': 'Past events',
                'showFutureEvents': 'Future events'
            }
        };
        const t = translations[currentLang] || translations['de'];

        // Filter Select Boxen aktivieren
        const sporttypeFilter = document.querySelector('#sporttype-filter');
        const cantonFilter = document.querySelector('#canton-filter');
        const categoryFilter = document.querySelector('#category-filter');
        const searchInput = document.querySelector('#searchFilter');

        // Aktive Filter definieren - verwende Sets um automatisch Duplikate zu vermeiden
        let activeSporttypeFilters = new Set();
        let activeCantonFilters = new Set();
        let activeCategoryFilters = new Set();

        // Aktueller Datumsfilter
        let currentDateFilter = null;

        // Alle Events speichern für Filterung
        let allEvents = [];
        let showingPastEvents = false;

        function isDatepickerInitialized(element) {
            return element.hasClass('hasDatepicker') || $(element).data('datepicker') !== undefined;
        }

        // jQuery Datepicker initialisieren
        function initDatepicker(eventDates = null) {
            const datePicker = $('#datepicker');
            if (isDatepickerInitialized(datePicker)) {
                datePicker.datepicker('destroy');
            }

            // Event-Daten: entweder als Parameter übergeben oder aus data-Attribut laden
            if (eventDates === null) {
                // jQuery's .data() parsed das JSON bereits automatisch
                eventDates = datePicker.data('eventdates') || [];
            }

            // Finde das erste Datum mit Events
            let defaultDate = new Date();
            if (eventDates.length > 0) {
                // Sortiere die Daten (für vergangene Events absteigend, für zukünftige aufsteigend)
                const sortedDates = showingPastEvents ? eventDates.sort().reverse() : eventDates.sort();
                // Nehme das erste Datum
                defaultDate = new Date(sortedDates[0]);
            }

            datePicker.datepicker({
                changeMonth: true,
                changeYear: true,
                dateFormat: "yy-mm-dd",
                defaultDate: defaultDate,
                beforeShowDay: function(date) {
                    // Nur Tage MIT Events aktivieren
                    let dateString = $.datepicker.formatDate('yy-mm-dd', date);
                    return [eventDates.indexOf(dateString) !== -1, ""];
                },
                onSelect: function(dateText) {
                    // Datumauswahl schliessen
                    $("#date-filter").removeClass("active");
                    // Datumsfilter setzen
                    currentDateFilter = dateText;
                    // Events filtern
                    filterAndDisplayEvents();
                    // Selected date Text aktualisieren
                    const dateObj = new Date(dateText);
                    const formatter = new Intl.DateTimeFormat(currentLang === 'de' ? 'de-CH' : currentLang + '-CH', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric'
                    });
                    $('#selected-date').text(formatter.format(dateObj));
                }
            });
        }

        // Event Datumsformat
        function dateFormatter() {
            return new Intl.DateTimeFormat('de-CH', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
            });
        }

        // Hilfsfunktion zum Dekodieren von HTML-Entities
        function decodeHtmlEntities(text) {
            const textarea = document.createElement('textarea');
            textarea.innerHTML = text;
            return textarea.value;
        }

        // Hilfsfunktion zur Erstellung ein Event Template
        function createEventElement(post, isFeatured = false) {
            // Definieren ob der Event in gross oder klein dargestellt werden soll
            let is_big_event = isFeatured || (post.acf && post.acf.event_type === 'games');

            // Hauptcontainer erstellen
            const eventItem = document.createElement('div');
            // Filter Klassen erstellen
            const filterClasses = [];

            // Sportarten
            if(post.acf && post.acf.event_sporttypes && post.acf.event_sporttypes.length > 0) {
                post.acf.event_sporttypes.forEach(function (sporttypeId) {
                    filterClasses.push('sporttype-' + sporttypeId);
                });
            }

            // Kantone
            if(post.acf && post.acf.event_cantons && post.acf.event_cantons.length > 0) {
                post.acf.event_cantons.forEach(function (canton) {
                    filterClasses.push('canton-' + canton);
                });
            }

            // Kategorien
            if(post.soswi_event_categories && post.soswi_event_categories.length > 0) {
                post.soswi_event_categories.forEach(function (categoryId) {
                    filterClasses.push('category-' + categoryId);
                });
            }

            // Datum für Filterung hinzufügen
            if(post.acf && post.acf.event_date_start) {
                const startDate = new Date(post.acf.event_date_start);
                const dateString = startDate.toISOString().split('T')[0];
                filterClasses.push('date-' + dateString);
            }

            if(is_big_event) {
                filterClasses.push('big-event-item');
            }

            eventItem.className = 'event-item ' + filterClasses.join(' ');

            // Suchbare Daten als data-Attribute speichern
            eventItem.dataset.title = post.title ? post.title.toLowerCase() : '';
            eventItem.dataset.sporttype = post.acf && post.acf.event_sporttype_txt ? post.acf.event_sporttype_txt.toLowerCase() : '';

            // Beitragsbild bei grossem Beitrag hinzufügen
            if(is_big_event && post.image && post.image.url && post.image.url.length > 0) {
                const leftHalf = document.createElement('div');
                leftHalf.className = 'event-left-half';
                const image = document.createElement('img');
                image.src = post.image.url;
                image.alt = post.image.alt;
                image.className = 'event-image';
                leftHalf.appendChild(image);
                eventItem.appendChild(leftHalf);
            }

            const innerContainer = document.createElement('div');
            innerContainer.className = 'event-inner-container';

            // Event-Meta Container (Datum links, Location rechts)
            const metaContainer = document.createElement('div');
            metaContainer.className = 'event-meta';

            // Datum hinzufügen (links)
            const startDate = new Date(post.acf && post.acf.event_date_start ? post.acf.event_date_start : new Date());
            const formatter = dateFormatter();
            const dateSpan = document.createElement('span');
            dateSpan.className = 'event-date';

            const dateIcon = document.createElement('i');
            dateIcon.className = 'fa-solid fa-calendar-days';

            const dateText = document.createTextNode(' ' + formatter.format(startDate));

            dateSpan.appendChild(dateIcon);
            dateSpan.appendChild(dateText);
            metaContainer.appendChild(dateSpan);

            // Location hinzufügen (rechts)
            if(post.acf && post.acf.event_location && post.acf.event_location.trim() !== '') {
                const locationSpan = document.createElement('span');
                locationSpan.className = 'event-location';

                const locationIcon = document.createElement('i');
                locationIcon.className = 'fa-solid fa-location-dot';

                const locationText = document.createTextNode(' ' + post.acf.event_location);

                locationSpan.appendChild(locationIcon);
                locationSpan.appendChild(locationText);
                metaContainer.appendChild(locationSpan);
            }

            innerContainer.appendChild(metaContainer);

            // Titel hinzufügen
            const titleHeading = document.createElement('h3');
            titleHeading.className = 'event-title';
            titleHeading.textContent = decodeHtmlEntities(post.title || 'Unbekannter Event');
            innerContainer.appendChild(titleHeading);

            // Kategorie hinzufügen
            const eventCategories = post.soswi_event_categories || [];
            if(eventCategories.length > 0) {
                let outputCategories = [];
                eventCategories.forEach(function(categoryId) {
                    if(categories[categoryId]) {
                        outputCategories.push(categories[categoryId]);
                    }
                });
                if(outputCategories.length > 0) {
                    const categorySpan = document.createElement('span');
                    categorySpan.className = 'event-category';
                    categorySpan.textContent = outputCategories.join(', ');
                    innerContainer.appendChild(categorySpan);
                }
            }

            // Event-Row erstellen
            const eventRow = document.createElement('div');
            eventRow.className = 'event-row';

            // Sports-Div hinzufügen
            const sportsDiv = document.createElement('div');
            sportsDiv.className = 'event-sports';
            // Wenn ein Sportarttext definiert ist, diesen Ausgeben
            if(post.acf && post.acf.event_sporttype_txt && post.acf.event_sporttype_txt.length > 0) {
                sportsDiv.textContent = post.acf.event_sporttype_txt;
            } else {
                const eventSporttypes = (post.acf && post.acf.event_sporttypes) ? post.acf.event_sporttypes : [];
                if(eventSporttypes.length > 0) {
                    let outputSporttypes = [];
                    eventSporttypes.forEach(function(sporttypeId) {
                        const sporttype = sporttypes[sporttypeId];
                        if(sporttype) {
                            outputSporttypes.push('<a href="'+sporttype.link+'" aria-label="'+sporttype.name+'">'+sporttype.name+'</a>');
                        }
                    });
                    if(outputSporttypes.length > 0) {
                        sportsDiv.innerHTML = outputSporttypes.join('');
                    }
                }
            }
            eventRow.appendChild(sportsDiv);

            // Link-Div hinzufügen
            const linkDiv = document.createElement('div');
            linkDiv.className = 'event-link';

            // Link erstellen
            const link = document.createElement('a');
            // WPML-korrekter Link verwenden (post.link enthält bereits die sprachspezifische URL)
            link.href = post.link || '';
            link.setAttribute('aria-label', t.eventLink);

            const linkText = document.createTextNode(t.eventLink + ' ');
            const linkIcon = document.createElement('i');
            linkIcon.className = 'fa-solid fa-arrow-right';

            link.appendChild(linkText);
            link.appendChild(linkIcon);
            linkDiv.appendChild(link);
            eventRow.appendChild(linkDiv);

            // Event-Row dem Hauptcontainer hinzufügen
            innerContainer.appendChild(eventRow);
            eventItem.appendChild(innerContainer);

            return eventItem;
        }

        // Hilfsfunktion: Prüft ob eine Option bereits im Select existiert
        function optionExists(selectElement, optionText) {
            for (let i = 0; i < selectElement.options.length; i++) {
                if (selectElement.options[i].textContent === optionText) {
                    return true;
                }
            }
            return false;
        }

        // Funktion, um Filter Auswahl vorzubereiten
        function generateFilterOptions(post) {
            // Sportarten Filter hinzufügen
            if(post.acf && post.acf.event_sporttypes && post.acf.event_sporttypes.length > 0) {
                post.acf.event_sporttypes.forEach(function (sporttypeId) {
                    // SportartId zum Set hinzufügen, nur wenn die Sportart existiert
                    if(sporttypes[sporttypeId] && sporttypes[sporttypeId].name && sporttypes[sporttypeId].name.trim() !== '') {
                        activeSporttypeFilters.add(sporttypeId);
                    }
                });
            }

            // Kanton Filter hinzufügen
            if(post.acf && post.acf.event_cantons && post.acf.event_cantons.length > 0) {
                post.acf.event_cantons.forEach(function (canton) {
                    // Kanton zum Set hinzufügen, nur wenn der Kanton nicht leer ist
                    if(canton && canton.trim() !== '') {
                        activeCantonFilters.add(canton.trim());
                    }
                });
            }

            // Kategorie Filter hinzufügen
            if(post.soswi_event_categories && post.soswi_event_categories.length > 0) {
                post.soswi_event_categories.forEach(function (categoryId) {
                    // Kategorie zum Set hinzufügen, nur wenn die Kategorie existiert
                    if(categories[categoryId] && categories[categoryId].trim() !== '') {
                        activeCategoryFilters.add(categoryId);
                    }
                });
            }
        }

        function writeFiltersToDom() {
            // Sportarten Filter schreiben
            if(activeSporttypeFilters.size > 0) {
                const sporttypeFragment = document.createDocumentFragment();
                // Set zu Array konvertieren und alphabetisch sortieren
                const sortedSporttypes = Array.from(activeSporttypeFilters).sort((a, b) => {
                    const nameA = sporttypes[a] ? sporttypes[a].name.toLowerCase() : '';
                    const nameB = sporttypes[b] ? sporttypes[b].name.toLowerCase() : '';
                    return nameA.localeCompare(nameB, 'de');
                });
                sortedSporttypes.forEach(function (sporttypeId) {
                    // Nur Sportarten mit gültigem Namen hinzufügen und Duplikate vermeiden
                    if(sporttypes[sporttypeId] && sporttypes[sporttypeId].name && sporttypes[sporttypeId].name.trim() !== '') {
                        const sportName = sporttypes[sporttypeId].name;
                        // Prüfen ob Option bereits existiert
                        if (!optionExists(sporttypeFilter, sportName)) {
                            const optionElement = document.createElement('option');
                            optionElement.value = '.sporttype-' + sporttypeId;
                            optionElement.textContent = sportName;
                            sporttypeFragment.appendChild(optionElement);
                        }
                    }
                });
                sporttypeFilter.appendChild(sporttypeFragment);
            }

            // Kanton Filter schreiben
            if(activeCantonFilters.size > 0) {
                const cantonFragment = document.createDocumentFragment();
                // Set zu Array konvertieren und alphabetisch sortieren, aber "Ausland" immer am Ende
                const sortedCantons = Array.from(activeCantonFilters).sort((a, b) => {
                    const auslandPattern = /^Ausland/i;
                    const aIsAusland = auslandPattern.test(a);
                    const bIsAusland = auslandPattern.test(b);

                    // Wenn einer der beiden "Ausland" ist, diesen nach hinten sortieren
                    if (aIsAusland && !bIsAusland) return 1;
                    if (!aIsAusland && bIsAusland) return -1;

                    // Wenn beide "Ausland" oder beide normale Kantone sind, alphabetisch sortieren
                    return a.toLowerCase().localeCompare(b.toLowerCase(), 'de');
                });
                sortedCantons.forEach(function (canton) {
                    // Nur Kantone mit gültigem Namen hinzufügen und Duplikate vermeiden
                    if(canton && canton.trim() !== '') {
                        // Prüfen ob Option bereits existiert
                        if (!optionExists(cantonFilter, canton)) {
                            const optionElement = document.createElement('option');
                            optionElement.value = '.canton-' + canton;
                            optionElement.textContent = canton;
                            cantonFragment.appendChild(optionElement);
                        }
                    }
                });
                cantonFilter.appendChild(cantonFragment);
            }

            // Kategorie Filter schreiben
            if(activeCategoryFilters.size > 0) {
                const categoryFragment = document.createDocumentFragment();
                // Set zu Array konvertieren und alphabetisch sortieren
                const sortedCategories = Array.from(activeCategoryFilters).sort((a, b) => {
                    const nameA = categories[a] ? categories[a].toLowerCase() : '';
                    const nameB = categories[b] ? categories[b].toLowerCase() : '';
                    return nameA.localeCompare(nameB, 'de');
                });
                sortedCategories.forEach(function (categoryId) {
                    // Nur Kategorien mit gültigem Namen hinzufügen und Duplikate vermeiden
                    if(categories[categoryId] && categories[categoryId].trim() !== '') {
                        const categoryName = categories[categoryId];
                        // Prüfen ob Option bereits existiert
                        if (!optionExists(categoryFilter, categoryName)) {
                            const optionElement = document.createElement('option');
                            optionElement.value = '.category-' + categoryId;
                            optionElement.textContent = categoryName;
                            categoryFragment.appendChild(optionElement);
                        }
                    }
                });
                categoryFilter.appendChild(categoryFragment);
            }
        }

        // Alle zukünftigen Events laden
        function loadFutureEvents() {
            showingPastEvents = false;
            loadEvents('/wp-json/soswi/v1/eventsapi/all');
        }

        // Alle vergangenen Events laden
        function loadPastEvents() {
            showingPastEvents = true;
            loadEvents('/wp-json/soswi/v1/eventsapi/past');
        }

        // Events laden (generisch)
        function loadEvents(apiUrl) {
            const eventsContainer = document.getElementById('eventsContainer');
            const toggleBtn = document.getElementById('togglePastEvents');

            if (!eventsContainer) {
                console.error('eventsContainer Element nicht gefunden!');
                return;
            }

            // Toggle Button während des Ladens disablen
            if (toggleBtn) {
                toggleBtn.disabled = true;
                toggleBtn.style.opacity = '0.5';
                toggleBtn.style.cursor = 'not-allowed';
            }

            // Filter-Sets vor dem Laden der neuen Events zurücksetzen
            activeSporttypeFilters.clear();
            activeCantonFilters.clear();
            activeCategoryFilters.clear();
            currentDateFilter = null;

            // Datumsfilter-Anzeige zurücksetzen
            const originalDateText = $('#selected-date').attr('data-original-text') || t.resetDate;
            $('#selected-date').text(originalDateText);

            // Loading Anzeige mit Spinner
            eventsContainer.innerHTML = '<div class="events-loading"><div class="spinner"></div><p>' + t.loadingEvents + '</p></div>';

            // API Route aufrufen
            fetch(`${apiUrl}?lang=${currentLang}`)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then(function (posts) {
                if (!posts || posts.length === 0) {
                    eventsContainer.innerHTML = '<p>' + t.noEvents + '</p>';
                    // Datepicker mit leeren Daten aktualisieren
                    initDatepicker([]);
                    return;
                }

                // Events speichern
                allEvents = posts;

                // Event-Daten für Datepicker extrahieren
                const eventDatesSet = new Set();
                posts.forEach(function (post) {
                    if (post.acf && post.acf.event_date_start && post.acf.event_date_end) {
                        const start = new Date(post.acf.event_date_start);
                        const end = new Date(post.acf.event_date_end);

                        // Alle Tage zwischen Start und Ende hinzufügen
                        const current = new Date(start);
                        current.setHours(0, 0, 0, 0);
                        end.setHours(0, 0, 0, 0);

                        while (current <= end) {
                            const dateString = current.toISOString().split('T')[0];
                            eventDatesSet.add(dateString);
                            current.setDate(current.getDate() + 1);
                        }
                    }
                });

                const eventDates = Array.from(eventDatesSet);

                // Datepicker mit neuen Event-Daten aktualisieren
                initDatepicker(eventDates);

                // Filter-Optionen generieren
                posts.forEach(function (post) {
                    generateFilterOptions(post);
                });

                // Filter schreiben
                writeFiltersToDom();

                // Events anzeigen
                displayEvents(posts);
            })
            .catch(error => {
                console.error('Fehler beim Laden der Events:', error);
                eventsContainer.innerHTML = '<p>' + t.errorLoading + '</p>';
            })
            .finally(() => {
                // Toggle Button wieder aktivieren
                if (toggleBtn) {
                    toggleBtn.disabled = false;
                    toggleBtn.style.opacity = '';
                    toggleBtn.style.cursor = '';
                }
            });
        }

        // Events anzeigen mit Games-Priorisierung (nur bei zukünftigen Events)
        function displayEvents(posts) {
            const eventsContainer = document.getElementById('eventsContainer');
            eventsContainer.innerHTML = '';

            if (!posts || posts.length === 0) {
                eventsContainer.innerHTML = '<p>' + t.noEvents + '</p>';
                return;
            }

            const fragment = document.createDocumentFragment();

            // Games-Priorisierung nur bei zukünftigen Events
            if (!showingPastEvents) {
                // Heutiges Datum
                const today = new Date();
                today.setHours(0, 0, 0, 0);

                // 7 Tage in der Zukunft
                const sevenDaysFromNow = new Date(today);
                sevenDaysFromNow.setDate(today.getDate() + 7);

                // Games Events innerhalb der nächsten 7 Tage finden
                const featuredGamesEvents = [];
                const regularEvents = [];

                posts.forEach(function (post) {
                    if (post.acf && post.acf.event_type === 'games' && post.acf.event_date_start) {
                        const eventStart = new Date(post.acf.event_date_start);
                        eventStart.setHours(0, 0, 0, 0);

                        // Wenn Event heute oder in den nächsten 7 Tagen startet
                        if (eventStart >= today && eventStart <= sevenDaysFromNow) {
                            featuredGamesEvents.push(post);
                        } else {
                            regularEvents.push(post);
                        }
                    } else {
                        regularEvents.push(post);
                    }
                });

                // Zuerst die Featured Games Events anzeigen
                featuredGamesEvents.forEach(function (post) {
                    const eventElement = createEventElement(post, true);
                    fragment.appendChild(eventElement);
                });

                // Dann die regulären Events
                regularEvents.forEach(function (post) {
                    const eventElement = createEventElement(post, false);
                    fragment.appendChild(eventElement);
                });
            } else {
                // Bei vergangenen Events: einfach alle chronologisch anzeigen (neueste zuerst)
                posts.forEach(function (post) {
                    const eventElement = createEventElement(post, false);
                    fragment.appendChild(eventElement);
                });
            }

            eventsContainer.appendChild(fragment);
        }

        // Events filtern und anzeigen
        function filterAndDisplayEvents() {
            const sporttypeValue = sporttypeFilter.value;
            const cantonValue = cantonFilter.value;
            const categoryValue = categoryFilter.value;
            const searchValue = searchInput ? searchInput.value.toLowerCase().trim() : '';

            let filteredEvents = allEvents.filter(function(post) {
                // Sportart Filter
                if (sporttypeValue !== '*') {
                    const sporttypeId = sporttypeValue.replace('.sporttype-', '');
                    if (!post.acf || !post.acf.event_sporttypes || !post.acf.event_sporttypes.includes(parseInt(sporttypeId))) {
                        return false;
                    }
                }

                // Kanton Filter
                if (cantonValue !== '*') {
                    const canton = cantonValue.replace('.canton-', '');
                    if (!post.acf || !post.acf.event_cantons || !post.acf.event_cantons.includes(canton)) {
                        return false;
                    }
                }

                // Kategorie Filter
                if (categoryValue !== '*') {
                    const categoryId = parseInt(categoryValue.replace('.category-', ''));
                    if (!post.soswi_event_categories || !post.soswi_event_categories.includes(categoryId)) {
                        return false;
                    }
                }

                // Datums Filter
                if (currentDateFilter) {
                    if (post.acf && post.acf.event_date_start && post.acf.event_date_end) {
                        const eventStart = new Date(post.acf.event_date_start);
                        const eventEnd = new Date(post.acf.event_date_end);
                        const filterDate = new Date(currentDateFilter);

                        eventStart.setHours(0, 0, 0, 0);
                        eventEnd.setHours(23, 59, 59, 999);
                        filterDate.setHours(0, 0, 0, 0);

                        // Event muss am gewählten Tag stattfinden (Start <= filterDate <= End)
                        if (!(eventStart <= filterDate && eventEnd >= filterDate)) {
                            return false;
                        }
                    } else {
                        return false;
                    }
                }

                // Such Filter
                if (searchValue) {
                    const title = post.title ? post.title.toLowerCase() : '';
                    const sporttype = post.acf && post.acf.event_sporttype_txt ? post.acf.event_sporttype_txt.toLowerCase() : '';

                    if (!title.includes(searchValue) && !sporttype.includes(searchValue)) {
                        return false;
                    }
                }

                return true;
            });

            displayEvents(filteredEvents);
        }

        // Filter Event Listener
        // global.js prüft ob es der Eventcalendar ist und überspringt dann
        sporttypeFilter.addEventListener('change', filterAndDisplayEvents);
        cantonFilter.addEventListener('change', filterAndDisplayEvents);
        categoryFilter.addEventListener('change', filterAndDisplayEvents);

        if (searchInput) {
            searchInput.addEventListener('input', filterAndDisplayEvents);
        }

        // Öffne/schliesse das Datum-Dropdown beim Klicken
        $('#date-filter').click(function(e) {
            e.stopPropagation();
            // Prüfen ob die Klassliste von e.target die Klasse ui-icon bzw deren container Icons enthält
            if(
                !(e.target.classList.contains('ui-icon') ||
                e.target.classList.contains('ui-datepicker-next') ||
                e.target.classList.contains('ui-datepicker-prev'))
            ) {
                $(this).toggleClass('active');
            }
        });

        // Schliesse Dropdown wenn außerhalb geklickt wird
        $(document).click(function(e) {
            if (!$(e.target).closest('#date-filter').length) {
                $('#date-filter').removeClass('active');
            }
        });

        // Datepicker Reset Button
        const resetDateBtn = $('<button type="button" class="reset-date-filter">' + t.resetDate + '</button>');
        resetDateBtn.on('click', function(e) {
            e.stopPropagation();
            currentDateFilter = null;
            $('#selected-date').text($('#selected-date').data('original-text') || $('#selected-date').attr('data-original-text'));
            $('#datepicker').datepicker('setDate', null);
            filterAndDisplayEvents();
        });

        // Reset Button zum Datepicker hinzufügen
        $('#datepicker').after(resetDateBtn);

        // Original Text speichern
        const originalDateText = $('#selected-date').text();
        $('#selected-date').data('original-text', originalDateText);
        $('#selected-date').attr('data-original-text', originalDateText);

        // Toggle Button für vergangene Events
        const toggleBtn = document.getElementById('togglePastEvents');
        if (toggleBtn) {
            toggleBtn.addEventListener('click', function() {
                if (showingPastEvents) {
                    // Zurück zu zukünftigen Events
                    loadFutureEvents();
                    toggleBtn.innerHTML = '<i class="fa-solid fa-clock-rotate-left"></i> <span class="btn-text">' + t.showPastEvents + '</span>';
                    toggleBtn.classList.remove('active');
                } else {
                    // Zeige vergangene Events
                    loadPastEvents();
                    toggleBtn.innerHTML = '<i class="fa-solid fa-calendar-check"></i> <span class="btn-text">' + t.showFutureEvents + '</span>';
                    toggleBtn.classList.add('active');
                }
            });
        }

        // Initialisierung
        initDatepicker();
        loadFutureEvents();

        // Event-Listener für Sprachwechsel und Navigation
        window.addEventListener('beforeunload', function() {
            // Filter vor dem Seitenwechsel zurücksetzen
            activeSporttypeFilters.clear();
            activeCantonFilters.clear();
            activeCategoryFilters.clear();
        });
    });
})(jQuery);
